import React, { Fragment, useEffect, useState } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { Button } from 'loyal-react'
import { Link } from 'react-router-dom'
import yn from 'yn'
import { history } from '../../redux'
import { getButton } from 'Shared/GTM/getButton'

const defaultState = {
  isHomeOrGuest: false,
  isHelpPage: false,
  isWishlistPage: false,
  isCartPage: false,
  profileMenu: false,
  userMenu: false,
  stateMenu: true,
  categoryMenu: false,
  showIuppMobileMenu: false
}

const MobileMenu = () => {
  const [ownState, setOwnState] = useState(defaultState)

  const callReset = e => {
    setOwnState({
      ...ownState,
      stateMenu: !ownState.stateMenu
    })
    if (
      !ownState.stateMenu ||
      ownState.categoryMenu ||
      ownState.userMenu
    ) {
      setTimeout(() => {
        setOwnState({
          ...ownState,
          profileMenu: false,
          userMenu: false,
          categoryMenu: false
        })
      }, 300)
    }
  }

  const closeMenu = () => {
    var checkMenu = document.getElementById('menuToggle')
    if (checkMenu && checkMenu.checked === true) {
      checkMenu.checked = false
    }
    callReset()

    if (ownState.showIuppMobileMenu === true) {
      setTimeout(() => {
        setOwnState({
          ...ownState,
          showIuppMobileMenu: false
        })
      }, 300)
    }
  }

  const activePage = () => {
    closeMenu()
    setTimeout(() => {
      var activeRoute = window.location.pathname.substring(
        window.location.pathname.lastIndexOf('/')
      )

      if (activeRoute === '/') {
        setOwnState({
          ...ownState,
          isHomeOrGuest: true,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (activeRoute === '/faq') {
        setOwnState({
          ...ownState,
          isHomeOrGuest: false,
          isHelpPage: true,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (
        activeRoute === '/profile' ||
        activeRoute === '/wishlist' ||
        activeRoute === '/extract' ||
        activeRoute === '/my-orders' ||
        activeRoute === '/my-address' ||
        activeRoute === '/scheduling'
      ) {
        setOwnState({
          ...ownState,
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: true,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (activeRoute === '/cart') {
        setOwnState({
          ...ownState,
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: true,
          showIuppMobileMenu: false
        })
      } else {
        setOwnState({
          ...ownState,
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      }
    }, 1)
  }

  const toggleMenuMobileIupp = (section) => {
    if (!ownState.showIuppMobileMenu) {
      const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] a, .placeholder-header, .iupp-header, .iupp-header a, .iupp-header button,  .iupp-header nav')
      if (allButtonsAndLinks && allButtonsAndLinks.length > 0) {
        Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
          buttonOrLink.setAttribute('aria-hidden', 'true')
        })
      }
    } else {
      const allButtonsAndLinks = document.querySelectorAll('[role="main"], [role="main"] a, .placeholder-header, .iupp-header, .iupp-header a, .iupp-header button,  .iupp-header nav')
      if (allButtonsAndLinks && allButtonsAndLinks.length > 0) {
        Array.from(allButtonsAndLinks).forEach(buttonOrLink => {
          buttonOrLink.removeAttribute('aria-hidden')
        })
      }
    }

    setOwnState({
      ...ownState,
      showIuppMobileMenu: !ownState.showIuppMobileMenu,
      isHomeOrGuest: !ownState.isHomeOrGuest
    })

    if (
      section === '#experiences' ||
      section === '#accumulatePoints' ||
      section === '#usePoint' ||
      section === '#benefits'
    ) {
      setTimeout(() => {
        document.querySelector(`.logo-header-link`).blur()
        document.querySelector(`${section} h2`).setAttribute('tabindex', '0')
        document.querySelector(`${section} h2`).focus()
        document.querySelector(`${section} h2`).addEventListener('blur', function () {
          document.querySelector(`${section} h2`).removeAttribute('tabindex')
        })
      }, 1000)
    }
  }

  const keyPressMenu = (e) => {
    if (e.which === 13) {
      toggleMenuMobileIupp()
    }
  }

  const returnHome = () => {
    history.push('/')
  }

  useEffect(() => {
    activePage()
  }, [])

  return (
    <div className='box-footer d-print-none'>
      <div className='box-footer-mobile'>
        <div className='container-footer footer-part-mobile bg-brand-2 container-fluid row mx-0 px-0'>
          <div
            className={`col px-0 d-flex justify-content-center ${
              ownState.isHomeOrGuest ? 'active' : 'inactive'
            }`}>
            <Link
              to='/'
              className='color-ui-white txt-body-sm d-flex justify-content-center'
              onClick={() => {
                activePage()
                getButton(false, 'home', 'clique:menu', 'ir-para-home')
              }}
              onFocus={callReset}
              role='button'
              tabIndex={0}
              aria-label='Início'
            >
              <i className='color-ui-white icon icon_home' aria-hidden='true' />
              <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                Início
              </p>
            </Link>
          </div>
          <div
            className={`col px-0 d-flex justify-content-center ${
              ownState.showIuppMobileMenu ? 'active' : 'inactive'
            }`}
          >
            {yn(process.env.REACT_APP_FOOTERIUPP) ? (
              <Fragment>
                <a className='color-ui-white txt-body-sm d-flex justify-content-center'
                  onClick={() => {
                    toggleMenuMobileIupp()
                    getButton(false, 'home', 'clique:menu', 'menu')
                  }}
                  onKeyPress={keyPressMenu}
                  onFocus={this.callReset}
                  tabIndex={0}
                  aria-label={ownState.showIuppMobileMenu ? 'Fechar' : 'Menu'}
                  aria-controls='collapseMenuMobile'
                  role='button'
                  aria-haspopup='true'
                  aria-expanded={ownState.showIuppMobileMenu}
                >
                  <i className={`color-${
                    ownState.showIuppMobileMenu
                      ? 'brand-6 txt-body'
                      : 'brand-5'
                  } icon icon_${
                    ownState.showIuppMobileMenu
                      ? 'menu_app_close'
                      : 'menu_app'
                  }`} aria-hidden='true' />
                  <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                    {ownState.showIuppMobileMenu ? 'Fechar' : 'Menu' }
                  </p>
                </a>

                <div className={ownState.showIuppMobileMenu ? 'open-menu-iupp menu-mobile-iupp' : 'close-menu-iupp menu-mobile-iupp'}>
                  <div className='menu-mobile menu'>
                    {ownState.showIuppMobileMenu && <nav aria-label='Menu' id='collapseMenuMobile' className='row h-100' arial-label='menu'>
                      <div className='col-12 '>
                        <ul>
                          {history.location.pathname === '/' ? (
                            <Fragment>
                              <li>
                                <AnchorLink
                                  onClick={() => {
                                    toggleMenuMobileIupp('#experiences')
                                    getButton(false, 'home', 'clique:menu', 'experiencias')
                                  }}
                                  href='#experiences'
                                  data-target='#experiences'
                                  className='link-font-mobile mn-item mn-experiences'
                                  tabIndex={0}>experiências</AnchorLink>
                              </li>
                              <li>
                                <AnchorLink
                                  onClick={() => {
                                    toggleMenuMobileIupp('#accumulatePoints')
                                    getButton(false, 'home', 'clique:menu', 'junte-pontos')
                                  }}
                                  href='#accumulatePoints'
                                  data-target='#accumulatePoints'
                                  className='link-font-mobile mn-item mn-accumulate-points'
                                  tabIndex={0}>junte pontos</AnchorLink></li>
                              <li>
                                <AnchorLink
                                  onClick={() => {
                                    toggleMenuMobileIupp('#usePoint')
                                    getButton(false, 'home', 'clique:menu', 'use-pontos')
                                  }}
                                  href='#usePoint'
                                  data-target='#usePoint'
                                  className='link-font-mobile mn-item mn-use-points'
                                  tabIndex={0}
                                >
                                  use pontos
                                </AnchorLink>
                              </li>
                              <li className='border-bottom border-color-ui-2 mb-2'>
                                <AnchorLink
                                  onClick={() => {
                                    toggleMenuMobileIupp('#benefits')
                                    getButton(false, 'home', 'clique:menu', 'beneficios')
                                  }}
                                  href='#benefits'
                                  data-target='#benefits'
                                  className='link-font-mobile mn-item mn-benefits'
                                  tabIndex={0}
                                >
                                  descontos
                                </AnchorLink>
                              </li>
                            </Fragment>
                          ) : (
                            <Fragment>
                              <li>
                                <a
                                  onClick={() => {
                                    returnHome()
                                    toggleMenuMobileIupp('#experiences')
                                    getButton(false, 'home', 'clique:menu', 'experiencias')
                                  }}
                                  href='#experiences'
                                  className='link-font-mobile mn-item mn-experiences'
                                  tabIndex={0}
                                  target='_blank'
                                >
                                  experiências
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={() => {
                                    returnHome()
                                    toggleMenuMobileIupp('#accumulatePoints')
                                    getButton(false, 'home', 'clique:menu', 'junte-pontos')
                                  }}
                                  href='#accumulatePoints'
                                  className='link-font-mobile mn-item mn-accumulate-points'
                                  tabIndex={0}
                                  target='_blank'
                                >
                                    junte pontos
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={() => {
                                    returnHome()
                                    toggleMenuMobileIupp('#usePoint')
                                    getButton(false, 'home', 'clique:menu', 'use-pontos')
                                  }}
                                  href='#usePoint'
                                  className='link-font-mobile mn-item mn-use-points'
                                  tabIndex={0}
                                  target='_blank'
                                >
                                  use pontos
                                </a>
                              </li>
                              <li className='border-bottom border-color-ui-2 mb-2'>
                                <a
                                  onClick={() => {
                                    returnHome()
                                    toggleMenuMobileIupp('#benefits')
                                    getButton(false, 'home', 'clique:menu', 'descontos')
                                  }}
                                  href='#benefits'
                                  className='link-font-mobile mn-item mn-benefits'
                                  tabIndex={0}
                                  target='_blank'
                                >
                                descontos
                                </a>
                              </li>
                            </Fragment>
                          )}

                          {yn(process.env.REACT_APP_HAS_POINTSANDCASH_LINK) && (
                            <li
                              data-href='/pointsandcash'
                            >
                              <Link
                                className='link-font-mobile mn-item'
                                onClick={() => {
                                  setOwnState({
                                    ...ownState,
                                    showIuppMobileMenu: !ownState.showIuppMobileMenu,
                                    isHomeOrGuest: !ownState.isHomeOrGuest
                                  })
                                  getButton(false, 'home', 'clique:menu', 'pontos-mais-dinheiro')
                                }}
                                to='/pointsandcash'
                                tabIndex={0}
                                target='_blank'
                              >
                                pontos + dinheiro
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_SECURITY_LINK) && (
                            <li
                              data-href='/security'
                            >
                              <Link
                                className='link-font-mobile mn-item'
                                onClick={() => {
                                  setOwnState({
                                    ...ownState,
                                    showIuppMobileMenu: !ownState.showIuppMobileMenu,
                                    isHomeOrGuest: !ownState.isHomeOrGuest
                                  })
                                  getButton(false, 'home', 'clique:menu', 'seguranca')
                                }}
                                to='/security'
                                tabIndex={0}
                                target='_blank'
                              >
                                segurança
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_REGULATION_LINK) && (
                            <li
                              data-href='/regulation'
                            >
                              <Link
                                className='link-font-mobile mn-item'
                                onClick={() => {
                                  setOwnState({
                                    ...ownState,
                                    showIuppMobileMenu: !ownState.showIuppMobileMenu,
                                    isHomeOrGuest: !ownState.isHomeOrGuest
                                  })
                                  getButton(false, 'home', 'clique:menu', 'regulamentos')
                                }}
                                to='/regulation'
                                tabIndex={0}
                                target='_blank'
                              >
                                regulamentos
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_PRIVACY_LINK) && (
                            <li
                              data-href='/privacy'
                            >
                              <Link
                                className='link-font-mobile mn-item'
                                onClick={() => {
                                  setOwnState({
                                    ...ownState,
                                    showIuppMobileMenu: !ownState.showIuppMobileMenu,
                                    isHomeOrGuest: !ownState.isHomeOrGuest
                                  })
                                  getButton(false, 'home', 'clique:menu', 'politica-de-privacidade')
                                }}
                                to='/privacy'
                                tabIndex={0}
                                target='_blank'
                              >
                                  política de privacidade
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_TERMS_LINK) && (
                            <li
                              data-href='/terms'
                            >
                              <Link
                                className='link-font-mobile mn-item'
                                onClick={() => {
                                  setOwnState({
                                    ...ownState,
                                    showIuppMobileMenu: !ownState.showIuppMobileMenu,
                                    isHomeOrGuest: !ownState.isHomeOrGuest
                                  })
                                  getButton(false, 'home', 'clique:menu', 'termos-de-uso')
                                }}
                                to='/terms'
                                tabIndex={0}
                                target='_blank'
                              >
                                  termos de uso
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_FAQ_LINK) && (
                            <li
                              data-href='/faq'
                            >
                              <Link
                                className='link-font-mobile mn-item'
                                onClick={() => {
                                  setOwnState({
                                    ...ownState,
                                    showIuppMobileMenu: !ownState.showIuppMobileMenu,
                                    isHomeOrGuest: !ownState.isHomeOrGuest
                                  })
                                  getButton(false, 'home', 'clique:menu', 'ajuda')
                                }}
                                to='/redirect/faq'
                                tabIndex={0}
                                target='_blank'
                              >
                                ajuda
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_CONTACT_LINK) && (
                            <li
                              data-href='/contact'
                            >
                              <Link
                                className='link-font-mobile mn-item'
                                onClick={() => {
                                  setOwnState({
                                    ...ownState,
                                    showIuppMobileMenu: !ownState.showIuppMobileMenu,
                                    isHomeOrGuest: !ownState.isHomeOrGuest
                                  })
                                  getButton(false, 'home', 'clique:menu', 'fale-conosco')
                                }}
                                to='/redirect/contact'
                                tabIndex={0}
                                target='_blank'
                              >
                                fale conosco
                              </Link>
                            </li>
                          )}

                          <li>
                            <Button
                              onClick={() => {
                                getButton(false, 'home', 'clique:menu', 'entrar')
                                window.location.href = '/auth/login'
                              }
                              }
                              text='entrar'
                              className='link-font-mobile mn-item mn-login'
                              tabIndex={0} /></li>
                          <li>
                            <Button
                              onClick={() => {
                                getButton(false, 'home', 'clique:menu', 'cadastre-se')
                                window.location.href = '/auth/login'
                              }}
                              text='cadastre-se'
                              className='link-font-mobile mn-item mn-register'
                              tabIndex={0} /></li>
                        </ul>
                      </div>
                    </nav> }
                  </div>
                </div>
              </Fragment>
            ) : (
              <Link
                to='/auth/login'
                onClick={() => getButton(false, 'home', 'clique:menu', 'menu')}
                className='color-ui-white txt-body-sm d-flex justify-content-center'
                tabIndex={0}
                aria-label='Menu'
                role='button'
              >
                <i className={`color-${
                  ownState.categoryMenu
                    ? 'brand-6 txt-body'
                    : 'brand-5'
                } icon icon_${
                  ownState.categoryMenu
                    ? 'menu_app_close'
                    : 'menu_app'
                }`} aria-hidden='true' />
                <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                  Menu
                </p>
              </Link>
            )}
          </div>
          <div
            className='col px-0 d-flex justify-content-center inactive'
          >
            <Link
              to='/auth/login'
              className='color-ui-white txt-body-sm d-flex justify-content-center'
              onClick={() => {
                this.activePage()
                getButton(false, 'home', 'clique:menu', 'cadastre-se')
              }}
              onFocus={this.callReset}
              tabIndex={0}
              aria-label='Cadastre-se'
              role='button'
            >
              <i className='color-brand-5 icon icon_login' aria-hidden='true' />
              <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                Cadastre-se
              </p>
            </Link>
          </div>
          <div
            className='col px-0 d-flex justify-content-center inactive'
          >
            <Link
              to='/auth/login'
              onClick={() => {
                getButton(false, 'home', 'clique:menu', 'entrar')
              }}
              className='color-ui-white txt-body-sm d-flex justify-content-center'
              tabIndex={0}
              aria-label='Entrar'
              role='button'
            >
              <i className={`color-ui-white icon icon_profile`} aria-hidden='true' />
              <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                Entrar
              </p>
            </Link>
          </div>
          {yn(process.env.REACT_APP_HAS_FAQ_LINK) && (
            <div
              className={`col px-0 d-flex justify-content-center ${
                ownState.isHelpPage ? 'active' : 'inactive'
              }`}
            >
              <Link to='/redirect/faq'
                className='color-ui-white txt-body-sm d-flex justify-content-center'
                onClick={() => {
                  this.activePage()
                  getButton(false, 'home', 'clique:menu', 'ajuda')
                }}
                onFocus={this.callReset}
                tabIndex={0}
                aria-label='Ajuda'
                role='button'
              >
                <i className={`color-ui-white icon icon_headphone`} aria-hidden='true' />
                <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile' aria-hidden='true'>
                  Ajuda
                </p>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default MobileMenu



// WEBPACK FOOTER //
// ./src/App/Footer/MobileMenu.js